import jpg_img from "../../../../../../../../assets/images/jpg.png";
import pdf_img from "../../../../../../../../assets/images/pdf.png";
import png_img from "../../../../../../../../assets/images/png.png";
import xlsx_img from "../../../../../../../../assets/images/xls.png";
import csv_img from "../../../../../../../../assets/images/csv-file.png";
import doc_img from "../../../../../../../../assets/images/docx-file.png";
import file_img_storage from "../../../../../../../../assets/images/file-storage.png";
import { AssignmentType } from "../../../../../../../../utils/consts";

export const getFileIcon = (fileName, ext = false) => {
  const extension = ext ? fileName : fileName
    .split(".")
    .pop()
    .toLowerCase();

  switch (extension) {
    case "pdf":
      return pdf_img;
    case "doc":
      return doc_img;
    case "docx":
      return doc_img;
    case "xls":
      return xlsx_img;
    case "xlsx":
      return xlsx_img;
    case "csv":
      return csv_img;
    case "jpg":
      return jpg_img;
    case "jpeg":
      return jpg_img;
    case "png":
      return png_img;
    default:
      return file_img_storage; // Default icon if the file type is not recognized
  }
};

export const getFileType = (fileName) => {
  const extension = fileName
    .split(".")
    .pop()
    .toLowerCase();
  switch (extension) {
    case "pdf":
      return "PDF";
    case "doc":
      return "Word";
    case "docx":
      return "Word";
    case "xls":
      return "Excel";
    case "xlsx":
      return "Excel";
    case "jpg":
      return "Image";
    case "jpeg":
      return "Image";
    case "png":
      return "Image";
    default:
      return "PDF"; // Default file type if not recognized
  }
};

// "https://youtu.be/cZH0YnFpjwU?si=..." -> "https://www.youtube.com/embed/cZH0YnFpjwU"
export function toEmbedUrl(raw) {
  try {
    const u = new URL(raw);
    const host = u.hostname.replace(/^www\./, "");

    let id = "";

    if (host === "youtu.be") {
      // https://youtu.be/VIDEO_ID
      id = u.pathname.slice(1);
    } else {
      // handles /embed/ID, /live/ID, /shorts/ID, /v/ID
      const pathMatch = u.pathname.match(/^\/(embed|live|shorts|v)\/([^/?#]+)/);
      if (pathMatch) {
        id = pathMatch[2];
      } else {
        // https://www.youtube.com/watch?v=VIDEO_ID
        id = u.searchParams.get("v") || "";
      }
    }

    id = (id || "").split("/")[0];

    if (!id) return raw; // not a recognizable YouTube url; leave as-is

    // carry over a start time if present (?t= / ?start=)
    const t = u.searchParams.get("t") || u.searchParams.get("start");
    const qs = new URLSearchParams();
    if (t) qs.set("start", /^\d+$/.test(t) ? t : t.replace(/[^\d]/g, ""));
    qs.set("enablejsapi", "1"); // lets timestamp buttons seek later

    const query = qs.toString();
    return `https://www.youtube.com/embed/${id}${query ? `?${query}` : ""}`;
  } catch {
    return raw;
  }
}

// Pull the iframe src out of saved lesson HTML and convert embed → watch URL.
// Returns "" if there's no youtube iframe.
export function extractYoutubeUrlFromHtml(html) {
  if (!html || typeof html !== "string") return "";

  // DOMParser unescapes &amp; → & for us, and reading .src/.getAttribute
  // gives the decoded value.
  let embedSrc = "";
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const iframe = doc.querySelector("iframe");
    embedSrc = iframe?.getAttribute("src") || "";
  } catch (e) {
    console.error("extractYoutubeUrlFromHtml parse failed:", e);
    return "";
  }
  if (!embedSrc) return "";

  // embed → normal watch URL
  try {
    const u = new URL(embedSrc);
    const host = u.hostname.replace(/^www\./, "");

    let id = "";
    if (u.pathname.startsWith("/embed/")) {
      id = u.pathname.split("/embed/")[1];
    } else if (host === "youtu.be") {
      id = u.pathname.slice(1);
    } else {
      id = u.searchParams.get("v") || "";
    }
    id = (id || "").split("/")[0];
    if (!id) return embedSrc; // not recognizable; return as-is

    // carry over a start time if present (embed uses ?start=, watch uses ?t=)
    const start = u.searchParams.get("start") || u.searchParams.get("t");

    let watchUrl = `https://www.youtube.com/watch?v=${id}`;
    if (start) watchUrl += `&t=${start}s`;
    return watchUrl;
  } catch (e) {
    console.error("extractYoutubeUrlFromHtml convert failed:", e);
    return embedSrc;
  }
}

// Use single backslashes for actual newlines
export function addLineBreaksAroundImages(data) {
  return data.replace(/(<img[^>]*\/?>)/g, " \n\n$1\n\n ");
}

export const getAssignmentTypeName = (type) => {
  return Object.values(AssignmentType).find((item) => {
    return item.value === type;
  })?.name;
};

export const handleassignmentnameKeyPress = (event) => {
  if (event.key === "Enter" && !event.shiftKey) {
    event.preventDefault();
  }
};

export const removeCloseImageSpans = (htmlString) => {
  // Create a temporary div to parse HTML safely
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // Find all spans with class 'graph_close_image' and remove them
  const closeImageSpans = tempDiv.querySelectorAll("span.graph_close_image");
  closeImageSpans.forEach((span) => {
    span.remove();
  });

  return tempDiv.innerHTML;
};

export const removeIframeCloseButtons = (htmlString) => {
  if (typeof htmlString !== "string" || htmlString.trim() === "") {
    return "";
  }

  try {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    const closeButtons = tempDiv.querySelectorAll(
      "button.iframe_node_close, button[title='Remove video']"
    );
    closeButtons.forEach((btn) => btn.remove());

    return tempDiv.innerHTML;
  } catch (error) {
    console.error("removeIframeCloseButtons: failed to parse HTML", error);
    return htmlString; // fail open — a stray icon beats a failed download
  }
};

export function getEditorContent() {
  // Replace this with the actual method to get content from your rich text editor
  return document.querySelector(".editor-input").innerHTML; // Example for plain text
}

export function Placeholder() {
  return <div className="editor-placeholder">Write / Paste content here</div>;
}

export function stripStyles(html) {
  // Create a temporary DOM element to manipulate
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Remove all style attributes
  const elements = tempDiv.querySelectorAll("[style]");
  elements.forEach((el) => el.removeAttribute("style"));

  // Return the cleaned HTML content
  return tempDiv.innerHTML;
}

export const defaultWorkboardContent = `<p class="editor-paragraph"><br></p>`;

/**
 * Normalizes various LaTeX/math delimiters to double-dollar format ($$...$$).
 * Handles \$...\$, \[...\], \\(...\\), single $...$ (when content looks like LaTeX), and \_.
 * @param {string} text - Raw text that may contain mixed math delimiters
 * @returns {string} Text with math normalized to $$...$$
 */
export function normalizeLatexToDoubleDollar(text) {
  if (text == null || typeof text !== "string") return text;
  return text
    .replace(/\\\$([\s\S]*?)\\\$/g, (_, content) => `$$${content}$$`)
    .replace(/\\\[(?!\d)([\s\S]*?)\\]/g, (_, content) => `$$${content.trim()}$$`)
    .replace(/\\\\\(([\s\S]*?)\\\\\)/g, (_, content) => `$$${content}$$`)
    .replace(/\\\(([\s\S]*?)\\\)/g, (_, content) => `$$${content}$$`)
    .replace(/\$([\s\S]*?)\$/g, (match, content, offset, string) => {
      if (content === "" || content === "$") return match;
      const beforeChar = offset > 0 ? string[offset - 1] : "";
      const afterChar = offset + match.length < string.length ? string[offset + match.length] : "";
      if (beforeChar === "$" || afterChar === "$") return match;
      const trimmed = content.trim();
      const hasBackslash = /\\+[a-zA-Z]+|\\[^\s\w]/.test(content);
      const hasKnownLatex = /\\+(?:in|mathbb|text|frac|sum|alpha|beta|times|leq|geq)\b/.test(content);
      const hasSubSuperscript = /[_^]/.test(trimmed);
      const hasCurlyBraces = /[{}]/.test(content);
      const hasMathOperators = /[=+\-*/<>≤≥±×÷]/.test(trimmed);
      const isPlainCurrency = /^\s*\d+([.,]\d+)?\s*$/.test(trimmed);
      const isLatex =
        (hasBackslash || hasKnownLatex || hasSubSuperscript || hasCurlyBraces || hasMathOperators) &&
        !isPlainCurrency;
      return isLatex ? `$$${content}$$` : match;
    })
    .replace(/\\_/, "_")
    // Replace 5 consecutive underscores only inside $$...$$ (LaTeX) with \text{\char95...}; leave plain-text _____ unchanged (e.g. 'a(n) _____ process').
    .replace(/\$\$([\s\S]*?)\$\$/g, (_, content) => `$$${content.replace(/_____/g, "\\text{\\char95\\char95\\char95\\char95\\char95}")}$$`);
}
